import React from 'react'
import { Box, Button, DialogContent, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'

// Inhouse components
import ClipboardTextHolder from '../../../common/ui/ClipboardTextHolder'

export default function BankTransferForm({ handleBack, handleSubmit }) {
  return (
    <>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          padding: '24px 38px'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
          }}
        >
          <Typography>
            Please take note of the following information when making a bank transfer
          </Typography>
          <Grid
            container
            spacing={{ xs: 4, md: 4 }}
            columns={{ xs: 2, sm: 8, md: 8 }}
            sx={{ marginTop: '16px' }}
          >
            <Grid item xs={2} sm={4} md={4}>
              <Box sx={{ marginBottom: '17px' }}>
                <Typography sx={{ color: '#818D9C', marginLeft: '12px' }}>
                  Recipient Bank:
                </Typography>
                <ClipboardTextHolder id='bankField'>DBS</ClipboardTextHolder>
              </Box>
              <Box sx={{ marginBottom: '17px' }}>
                <Typography sx={{ color: '#818D9C', marginLeft: '12px' }}>
                  Recipient account number:
                </Typography>
                <ClipboardTextHolder id='accountField'>
                  0987651
                </ClipboardTextHolder>
              </Box>
              <Box sx={{ marginBottom: '17px' }}>
                <Typography sx={{ color: '#818D9C', marginLeft: '12px' }}>
                  Recipient name:
                </Typography>
                <ClipboardTextHolder id='nameField'>
                  Liberty Wireless
                </ClipboardTextHolder>
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <Box sx={{ marginBottom: '17px' }}>
                <Typography sx={{ color: '#818D9C', marginLeft: '12px' }}>
                  Swift/BIC Code:
                </Typography>
                <ClipboardTextHolder id='swiftBICField'>
                  DBSSSGSG
                </ClipboardTextHolder>
              </Box>
              <Box sx={{ marginBottom: '17px' }}>
                <Typography sx={{ color: '#818D9C', marginLeft: '12px' }}>
                  Transaction reference Number:
                </Typography>
                <ClipboardTextHolder id='refNumField'>
                  1234567890
                </ClipboardTextHolder>
              </Box>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Button
              id='backBtn'
              sx={{ marginTop: '10px' }}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              type='submit'
              id='transferredBtn'
              sx={{ marginTop: '10px' }}
              variant='contained'
              onClick={handleSubmit}
              data-cy='bankTrfSubmitBtn'
            >
              Proceed
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </>
  )
}

BankTransferForm.propTypes = {
  handleBack: PropTypes.func,
  handleSubmit: PropTypes.func
}
